<template>
  <SysDataTableExpand
    :headers="CABECALHOS"
    :height="alturaDaJanela - 219"
    :item-height="45"
    :itemClass="cssLinha"
    :callbacks="CALLBACKS"
    @click:row="exportarDadosLinha"
    @callback-resetar-grid="fn => callbackResetarDadosGrid = fn"
  >
    <template #_item.descricao_analise="{item}">
      <div class="d-flex align-center">
        <DetalhesProduto v-if="item.idproduto && !item.produto_combinado"
          :produto="{ id_grupo: item.idgrupo, id_filial: 9999, id_produto: item.idproduto }" />
        <span v-text="item.descricao_analise" class="text-truncate" />
      </div>
    </template>

    <template #item.qtde_produtos="{ item }">
      {{ item.idproduto ? '-' : Helpers.formatarValor(item.qtde_produtos) }}
    </template>

    <template #item.estoque_em_preco_custo="{ value }">
      {{ `R$ ${Helpers.formatarValor(value)}` }}
    </template>

    <template #item.estoque_parametrizavel_preco_custo="{ value }">
      {{ `R$ ${Helpers.formatarValor(value)}` }}
    </template>

    <template #item.estoque="{ value }">
      {{ Helpers.formatarValor(value) }}
    </template>

    <template #item.estoque_parametrizavel="{ value }">
      {{ Helpers.formatarValor(value) }}
    </template>
  </SysDataTableExpand>
</template>

<script>
import SysDataTableExpand from "@/components/utils/dataTable/sysDataTableExpand/Index";
import ResponsiveHeight from '@/helpers/ResponsiveHeight';
import * as requisicoes from '@/api/Diagnostico/SlowNoMoving/SlowNoMoving';
import DetalhesProduto from "@/components/produto/detalhes/Index";

export default {
  name: "Tabela",
  mixins: [ResponsiveHeight],
  components: {
    DetalhesProduto,
    SysDataTableExpand
  },
  props: {
    tipo_visao: String
  },
  data: () => ({
    linha_clicada: null,
    todas_histogramas: null,
    callbackResetarDadosGrid: null,
    tipos_cabecalhos: {
      financeiro: [
        { text: 'Análise', value: 'descricao_analise' },
        { text: "Total de Sku's", value: 'qtde_produtos' },
        { text: "Saldo atual de estoque em preço de custo", value: 'estoque_em_preco_custo', style: { width: '20%' } },
        { text: "Saldo ideal  em preço de custo (Parametrizável)", value: 'estoque_parametrizavel_preco_custo', style: { width: '20%' } },
      ],
      quantitativo: [
        { text: 'Análise', value: 'descricao_analise' },
        { text: "Total de Sku's", value: 'qtde_produtos' },
        { text: "Saldo atual de estoque", value: 'estoque', style: { width: '20%' } },
        { text: "Saldo ideal (Parametrizável)", value: 'estoque_parametrizavel', style: { width: '20%' } },
      ]
    }
  }),
  computed: {
    CABECALHOS() {
      if (this.tipo_visao === 'F') {
        return this.tipos_cabecalhos.financeiro
      }
      return this.tipos_cabecalhos.quantitativo;
    },
    FILTROS_STORE() {
      return this.$store.getters['filtrosUniversalAvancado/filtros_formatados'];
    },
    CALLBACKS() {
      const funcoes = [
        this.buscarSlowNoMoving,
        this.buscarSlowNoMovingPorSegmento,
        this.buscarSlowNoMovingPorFornecedor,
        this.buscarSlowNoMovingPorProduto,
      ];

      if (localStorage.diagnostico_ocultar_nivel_fornecedor === 'S') {
        return funcoes.filter(f => f !== this.buscarSlowNoMovingPorFornecedor);
      }

      return funcoes;
    }
  },
  watch: {
    FILTROS_STORE() {
      this.callbackResetarDadosGrid();
    },
  },
  methods: {
    async buscarSlowNoMoving() {
      const linhas = await requisicoes.buscarAnaliseGeral(this.FILTROS_STORE);
      linhas.unshift(this.gerarTotalizadorHistograma(linhas));
      this.todas_histogramas = linhas.map(p => p.descricao_niveis);
      return linhas;
    },
    gerarTotalizadorHistograma(linhas) {
      const item_totalizador = {
        $nao_expansivel: true,
        totalizador: true,
        descricao_niveis: 'Total geral',
        descricao_analise: 'Total geral',
        qtde_produtos: 0,
        estoque_em_preco_custo: 0,
        estoque_parametrizavel_preco_custo: 0,
        estoque: 0,
        estoque_parametrizavel: 0,
      };

      const callback = (acumulado, a) => {
        acumulado.qtde_produtos += Number(a.qtde_produtos);
        acumulado.estoque_em_preco_custo += Number(a.estoque_em_preco_custo);
        acumulado.estoque_parametrizavel_preco_custo += Number(a.estoque_parametrizavel_preco_custo);
        acumulado.estoque += Number(a.estoque);
        acumulado.estoque_parametrizavel += Number(a.estoque_parametrizavel);
        return acumulado;
      }

      return linhas.reduce(callback, item_totalizador);
    },
    async buscarSlowNoMovingPorSegmento({histograma}) {
      const parametros = {
        histograma,
        ...this.FILTROS_STORE
      };
      return await requisicoes.buscarAnalisePorSegmentos(parametros);
    },
    async buscarSlowNoMovingPorFornecedor(linha) {
      if (linha.descricao_analise === 'COMBINADOS') {
        linha.produto_combinado = true;
        return await this.buscarSlowNoMovingPorProduto(linha);
      }

      const parametros = {
        histograma: linha.histograma,
        idsegmento: `${linha.idsegmento}`,
        ...this.FILTROS_STORE
      };
      return await requisicoes.buscarAnalisePorFornecedores(parametros);
    },
    async buscarSlowNoMovingPorProduto({histograma, idsegmento, idfornecedor, produto_combinado}) {
      const parametros = {
        histograma,
        idsegmento: `${idsegmento}`,
        idfornecedor: `${idfornecedor || 0}`,
        produto_combinado: produto_combinado ? 'S' : 'N',
        ...this.FILTROS_STORE
      };
      const itens = await requisicoes.buscarAnalisePorProdutos(parametros);
      return itens.map(item => ({
        ...item,
        $nao_expansivel: produto_combinado,
        produto_combinado
      }));
    },
    exportarDadosLinha({ row }) {
      if (this.linha_clicada === row) {
        this.$emit('duplo-click:linha', {...row, histogramas: [row.histograma]});
      }

      if (row.totalizador) {
        this.$emit('duplo-click:linha', { ...row, histogramas: this.todas_histogramas});
      }

      this.linha_clicada = row;
      setTimeout(() => this.linha_clicada = null, 500);
    },
    cssLinha(linha) {
      return {
        'font-weight-bold': linha.totalizador,
        'cursor-pointer': true
      }
    }
  }
}
</script>

<style scoped>

</style>
